import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { BackdoorApiService } from '@app/core/service/api/backdoor.api.service';
import { DirectivesModule } from '@app/modules/directives.module';
import { FullHeightContainerModule } from '@app/modules/full-height-container/full-height-container.module';
import { IonicModule } from '@ionic/angular';
import { BackdoorEulaModalComponent } from './backdoor-eula-modal.component';

@NgModule({
  imports: [
    CommonModule,
    IonicModule,
    DirectivesModule,
    FullHeightContainerModule
  ],
  declarations: [BackdoorEulaModalComponent],
  providers: [BackdoorApiService]
})
export class BackdoorEulaModalModule {}
